import React, { Fragment, Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import d3Tip from "d3-tip";
import PropTypes from "prop-types";
import "./brushStyle.scss";

class BrushBarChart extends Component {
  state = {
    animate: false,
  };
  componentDidMount() {
    var { data, width, height } = this.props;
    var id = `#${this.props.id}`;
    if (data.length <= 0) {
      return;
    }
    // group bar data conversion
    let Data = this.dataModify(data);
    // chart display function
    this.ChartDisplay(Data, id, width, height);
  }

  componentWillReceiveProps(props) {
    var { data, width, height } = props;
    let id = `#${this.props.id}`;

    //clear old chart
    $(id).empty();
    // d3.select(id).empty()
    if (data.length <= 0) {
      return;
    }
    let Data = this.dataModify(data);
    this.ChartDisplay(Data, id, width, height);
  }

  dataModify = (data) => {
    let groupRect = d3.keys(data[0]).filter(function (key) {
      return key !== "metric_name" && key !== "groupRect" && key !== "key";
    });
    var Data = data.map((a) => Object.assign({}, a));
    Data.forEach(function (d, i) {
      d.key = i;
      d.groupRect = groupRect.map(function (name) {
        return { name: name, value: +d[name] };
      });
    });
    return Data;
  };

  ChartDisplay = (data, id, width, height) => {
    // document.getElementById("reset_brushChart").style.display = "none";

    var margin = { top: 10, right: 10, bottom: 200, left: 40 },
      margin2 = { top: 450, right: 10, bottom: 50, left: 40 },
      w = width - margin.left - margin.right,
      h = height - margin.top - margin.bottom,
      h2 = height - margin2.top - margin2.bottom;

    var x = d3.scale.ordinal().rangeBands([0, w], 0.1),
      x2 = d3.scale.ordinal().rangeBands([0, w], 0.1),
      y = d3.scale.linear().range([h, 0]),
      y2 = d3.scale.linear().range([h2, 0]);

    // group bar data conversion
    let Color = d3.scale.ordinal().range(["#81efde", "#4c6ead", "#8775a7"]);
    let groupRect = d3.keys(data[0]).filter(function (key) {
      return key !== "metric_name" && key !== "groupRect";
    });

    var xAxis = d3.svg.axis().scale(x).orient("bottom"),
      xAxis2 = d3.svg.axis().scale(x2).orient("bottom"),
      // .tickValues(data.map(d => d.metric_name)),
      // .tickValues(["2018", "2019", "2020", "20", 5]),
      // d3.time.format("%b %Y")
      yAxis = d3.svg.axis().scale(y).orient("left").innerTickSize(-w);

    x.domain(data.map((d) => d.metric_name));
    y.domain([
      d3.min(data, function (d) {
        return d3.min(d.groupRect, function (d) {
          if (d.value > 0) return 0;
          else {
            return d.value;
          }
        });
      }),
      d3.max(data, function (d) {
        return d3.max(d.groupRect, function (d) {
          if (d.value < 0) return 0;
          else {
            return d.value;
          }
        });
      }),
    ]);
    x2.domain(x.domain());
    y2.domain(y.domain());

    var brush = d3.svg.brush().x(x2).on("brush", brushed);

    var svg = d3
      .select(id)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", h + margin.top + margin.bottom);

    var focus = svg
      .append("g")
      .attr("class", "focus")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    // axis
    focus
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + h + ")")
      .call(xAxis);

    focus.append("g").attr("class", "y axis").call(yAxis);

    // group bar
    var group_bar_holder = focus.append("g").attr("class", "group-bar-holder");

    var context = svg
      .append("g")
      .attr("class", "context")
      .attr("transform", "translate(" + margin2.left + "," + margin2.top + ")");

    enter(data);
    updateScale(data);

    var subBars = context.selectAll(".subBar").data(data);

    subBars
      .enter()
      .append("rect")
      .classed("subBar", true)
      .attr({
        height: function (d) {
          return h2 - y2(d.benchmark);
        },
        width: (d) => x.rangeBand(),
        x: (d) => x2(d.metric_name),
        y: (d) => y2(d.benchmark),
      });

    function brushed() {
      // var selected = null;
      var selected = x2.domain().filter(function (d) {
        return brush.extent()[0] <= x2(d) && x2(d) <= brush.extent()[1];
      });

      var start;
      var end;
      if (brush.extent()[0] !== brush.extent()[1]) {
        start = selected[0];
        end = selected[selected.length - 1];
      } else {
        start = 0;
        end = data.length;
      }

      // var updatedData = data.slice(start, end);
      var updatedData = data.filter(function (d) {
        var date = new Date(d.metric_name);

        return date >= new Date(start) && date <= new Date(end);
      });

      update(updatedData);
      enter(updatedData);
      // exit(updatedData);
      updateScale(updatedData);
    }

    context
      .append("g")
      .attr("class", "x axis concept_xAxis")
      .attr("transform", "translate(0," + h2 + ")")
      .call(xAxis2)
      .selectAll("text")
      .style("text-anchor", "middle")
      .attr("font-size", "6px")
      .attr("dx", "0em")
      .attr("dy", ".813em")
      .attr("y", "0")
      .attr("x", "-28")
      .attr("transform", (d) => "rotate(-90)");

    context
      .append("g")
      .attr("class", "x brush")
      .call(brush)
      .selectAll("rect")
      .attr("y", -6)
      .attr("height", h2 + 7);

    function updateScale(data) {
      var tickScale = d3.scale
        .pow()
        .range([data.length / 10, 0])
        .domain([data.length, 0])
        .exponent(0.5);

      var brushValue = brush.extent()[1] - brush.extent()[0];
      if (brushValue === 0) {
        brushValue = w;
      }

      if (data.length > 20) {
        var tickValueMultiplier = Math.ceil(Math.abs(tickScale(brushValue)));
        let x = Math.round(tickValueMultiplier / 2);
        var filteredTickValues = data
          .filter(function (d, i) {
            return i % x === 0;
          })
          .map((d) => d.metric_name);
        focus.select(".x.axis").call(xAxis.tickValues(filteredTickValues));
      } else {
        let filtered = data.map((d) => d.metric_name);
        focus.select(".x.axis").call(xAxis.tickValues(filtered));
      }

      focus.select(".y.axis").call(yAxis);
    }

    function Tip() {
      return d3Tip()
        .attr("class", "d3-tip")
        .offset([-10, 0])
        .html(function (d) {
          return `<strong class="text-capitalize">${
            d.name.toLowerCase() === "funds" ? "Portfolio" : d.name
          } : </strong> <span> ${d.value.toFixed(2)}% </span>`;
        });
    }

    function update(data) {
      var tip = Tip();

      //   document.getElementById("reset_brushChart").style.display = "block";

      let x1 = d3.scale.ordinal();
      x1.domain(groupRect).rangeRoundBands([0, x.rangeBand()]);
      x.domain(data.map((d) => d.metric_name));

      y.domain([
        d3.min(data, function (d) {
          return d3.min(d.groupRect, function (d) {
            if (d.value > 0) return 0;
            else {
              return d.value;
            }
          });
        }),
        d3.max(data, function (d) {
          return d3.max(d.groupRect, function (d) {
            if (d.value < 0) return 0;
            else {
              return d.value;
            }
          });
        }),
      ]);

      $(".brush_groups").remove();
      // var group_bar_holder = focus.append("g").attr("class", "group-bar-holder");
      var bars = group_bar_holder
        .selectAll(".brush_groups")
        .data(data)
        // .enter()
        .append("g")
        .attr("class", "brush_groups")
        .attr("transform", function (d) {
          return `translate(${x(d.metric_name)},${0})`;
        });

      bars
        .selectAll("rect")
        .data((d) => d.groupRect)
        .enter()
        .append("rect")
        .attr("Value", (d) => d.value)
        .attr("Name", (d) => d.name)
        .attr("rx", 8)
        .attr("ry", 8)
        .attr("x", (d) => x1(d.name))
        .attr("y", function (d) {
          if (d.value >= 0) {
            return y(d.value);
          } else {
            return y(0);
          }
        })
        .attr("width", x1.rangeBand())
        .attr("height", function (d) {
          return Math.abs(y(d.value) - y(0));
        })
        .style("fill", (d) => Color(d.name))
        .on("mouseover", tip.show)
        .on("mouseout", tip.hide);

      // tooltip call
      bars.call(tip);
    }

    // function exit(data) {
    //   var group_bar_holder = focus
    //     .append("g")
    //     .attr("class", "group-bar-holder");

    //   var bars = group_bar_holder
    //     .selectAll(".brush_groups")
    //     .data(data)
    //     .enter()
    //     .append("g")
    //     .attr("class", "brush_groups")
    //     .attr("transform", function(d) {
    //       return `translate(${x(d.portfolio)},${0})`;
    //     });

    //   bars.exit().remove();
    //   enter(data);
    // }

    function enter(data) {
      var tip = Tip();

      let x1 = d3.scale.ordinal();
      x1.domain(groupRect).rangeRoundBands([0, x.rangeBand()]);

      x.domain(data.map((d) => d.metric_name));
      y.domain([
        d3.min(data, function (d) {
          return d3.min(d.groupRect, function (d) {
            if (d.value > 0) return 0;
            else {
              return d.value;
            }
          });
        }),
        d3.max(data, function (d) {
          return d3.max(d.groupRect, function (d) {
            if (d.value < 0) return 0;
            else {
              return d.value;
            }
          });
        }),
      ]);

      var bars = group_bar_holder
        .selectAll(".brush_groups")
        .data(data)
        .enter()
        .append("g")
        .attr("class", "brush_groups")
        .attr("transform", function (d) {
          return `translate(${x(d.metric_name)},${0})`;
        });

      bars
        .selectAll("rect")
        .data((d) => d.groupRect)
        .enter()
        .append("rect")
        .attr("Value", (d) => d.value)
        .attr("Name", (d) => d.name)
        .attr("rx", 8)
        .attr("ry", 8)
        .attr("x", (d) => x1(d.name))
        .attr("y", function (d) {
          if (d.value >= 0) {
            return y(d.value);
          } else {
            return y(0);
          }
        })
        .attr("width", x1.rangeBand())
        .attr("height", function (d) {
          return Math.abs(y(d.value) - y(0));
        })
        .style("fill", (d) => Color(d.name))
        .on("mouseover", tip.show)
        .on("mouseout", tip.hide);

      // tooltip call
      bars.call(tip);
    }
  };

  resetData = () => {
    var { width, height, data } = this.props;
    let id = `#${this.props.id}`;

    $(id).empty();

    if (data.length <= 0) {
      return;
    }

    let Data = this.dataModify(data);
    this.ChartDisplay(Data, id, width, height);
    this.setState({
      animate: !this.state.animate,
    });
    // document.getElementById("reset_brushChart").style.display="none";
  };

  render() {
    const { animate } = this.state;
    return (
      <Fragment>
        <span
          className="fa-stack fadeIn"
          id="reset_brushChart"
          onClick={this.resetData}
        >
          <i className="fa fa-circle fa-stack-2x"></i>
          <i
            className={
              animate
                ? "fa fa-undo fa-stack-1x fa-inverse animate360"
                : "fa fa-undo fa-stack-1x fa-inverse"
            }
          ></i>
        </span>
        <div id={this.props.id} className="bar_01" />
      </Fragment>
    );
  }
}

BrushBarChart.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      portfolio: PropTypes.number.isRequired,
      benchmark: PropTypes.number.isRequired,
      metric_name: PropTypes.string.isRequired,
    })
  ),
};

export default BrushBarChart;



// WEBPACK FOOTER //
// ./src/components/d3Components/NewBarchart/BrushBarChart.jsx